import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'highlightSearch',
})
export class HighlightSearchPipe implements PipeTransform {
  highlightSearchTerms(source: string, terms: string, patternStart = '<strong>', patternEnd = '</strong>'): string {
    const words = terms.split(/[ ]+/);
    const giReplaceTerms = words.join('|');

    const sourceWords = source.split(' ');
    return sourceWords.reduce((result, word) => {
      const re = new RegExp(giReplaceTerms, 'gi');
      let newWord = word.replace(re, (x) => {
        return patternStart + x + patternEnd;
      });
      if (word === newWord && terms.length > 2 && word.indexOf(terms) > -1) {
        newWord = word.replace(terms, patternStart + terms + patternEnd);
      }

      return (result ? result + ' ' : '') + newWord;
    }, '');
  }

  transform(value: string, search: string): string {
    if (!value) return '';
    if (!search) return value;

    const valueStr = value + ''; // Ensure numeric values are converted to strings

    // for performance reason, we ignore the case one word contains multiple search terms!!!
    return this.highlightSearchTerms(valueStr, search);
  }
}
